import { Module } from "wrapper6";
import GA4TrackingHandler from './_ga4-tracking-handler'
/* global jQuery */

var $ = jQuery;

export default class CalendarFilter extends Module {
    ready(app) {
        let that = this;
        this.SEARCH_BTN = $('.filter-search-btn');
        this.TOGGLES = $('.nav-filter .toggles');
        this.LOADER = $('#calender-area .loader-overlay');
        this.SEARCH_BTN.on('click', (e) => {
            e.preventDefault();
            that.search.call(that,e);
            this.TOGGLES.removeClass('open');
            that.updateEditIcons.call(that);
        });
        this.MONTH_FILTER = $('#month-toggle');
        this.MONTH_FILTER.on('click', (e) => that.updateMonthEventCount.call(that, e));
        this.MONTH_LOADER = $('#month-loader');

        this.UNIVERSE_FILTER = $('#universe-toggle');
        this.UNIVERSE_FILTER.on('click', (e) => that.updateUniverseEventCount.call(that, e));
        this.UNIVERSE_LOADER = $('#universe-loader');

        this.LOCATION_FILTER = $('#location-toggle');
        this.LOCATION_FILTER.on('click', (e) => that.updateLocationEventCount.call(that, e));
        this.LOCATION_LOADER = $('#location-loader');

        $('.dropdown-inner input[type="checkbox"].select-all').on('change', function(e){
            $(e.target).closest('.dropdown-inner').find("input[type='checkbox']").prop('checked', $(e.target).prop('checked'));
            that.updateEditIcons.call(that);
        });

        $('.dropdown-inner input[type="checkbox"].single-select').on('change', function(e){
            let filter_parent = $(e.target).closest('.dropdown-inner');
            let checked_options = filter_parent.find("input[type='checkbox'].single-select:checked");
            filter_parent.find("input[type='checkbox'].select-all").prop('checked', checked_options.length <= 0);

            that.updateEditIcons.call(that);
        });
        that.updateEditIcons.call(that);
    }

    updateEditIcons(){
        let edited_class = 'edited';

        this.TOGGLES.find('.toggle').each(function(i,toggle_el){
            let toggle = jQuery(toggle_el);
            let title = jQuery(toggle_el).find('.title');
            let all_selected = toggle.find('input.select-all').prop('checked');
            title.toggleClass(edited_class,!all_selected);
        });
    }

    getFilters(type){
        let types = $('.dropdown-inner input[type=checkbox]:checked.'+type);
        return $.map(types, (type) => {
            return $(type).data('filter-value');
        });
    }

    getTypes(){
        return this.getFilters('post-type');
    }

    getLocations(){
        return this.getFilters('location');
    }

    getUniverses(){
        return this.getFilters('universe');
    }

    getMonths(){
        return this.getFilters('month');
    }

    getMonthCounts(){
        return $('.dropdown-inner .month-count');
    }

    getUniverseCounts(){
        return $('.dropdown-inner .universe-count');
    }

    getFilterCounts(type){
        return $(`.dropdown-inner .${type}-count`);
    }

    get isELearning(){
        return $('#filter-toggle').data('filter-type') === 'e-learning';
    }

    get filterAction(){
        if(this.isELearning){
            return 'e_learning_by_universe'
        }

        return 'search_events';
    }

    search(){

        this.LOADER.addClass('show');

        let url = window.main_theme_objects.ajax_url;

        let types = this.getTypes();
        let locations = this.getLocations();
        let universes = this.getUniverses();
        let months = this.getMonths();

        let data = {
            'action': this.filterAction,
            'post_types': types,
            'locations': locations,
            'universes': universes,
            'months': months,
        };

        let that = this;

        $.ajax({
            type: "POST",
            url: url,
            data: data,
        }).done((response) => {
            $('#calender-sections').html(response.markup);
            history.pushState({}, 'Kalender', response.url);
            that.getMonthCounts().each((index, el) => {
                $(el).html(response.event_counts[index + 1] ? response.event_counts[index + 1] : 0);
            });

            GA4TrackingHandler.addViewItemListOnPageLoad(
              '#calender-area',
              {
                item_list_id: 'calendar__search__view-list-items',
                item_list_name: response.ga4_title,
              }
            )

            this.LOADER.removeClass('show');
        }).error((response) => {
            console.error('AJAX Error Response',response);
        });
    }

    toggleLoader(loader, show) {
        $(loader).toggleClass('show', show);
    }

    updateMonthEventCount(){
        this.toggleLoader(this.MONTH_LOADER, true);

        let data = {
            'action': 'get_event_count',
            'post_types': this.getTypes(),
            'locations': this.getLocations(),
            'universes': this.getUniverses(),
        };

        let that = this;

        $.ajax({
            type: "POST",
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).done((response) => {
            that.updateCountByType('month', response.event_counts);
            that.toggleLoader(that.MONTH_LOADER,false);
        }).error((response) => {
            that.toggleLoader(that.MONTH_LOADER,false);
            console.error('AJAX Error Response',response);
        });
    }

    updateUniverseEventCount(){
        this.toggleLoader(this.UNIVERSE_LOADER, true);

        let filterType = $('#filter-toggle').data('filter-type');

        if(filterType === 'e-learning'){
            return this.updateUniverseEventCountELearning();
        }

        return this.updateUniverseEventCountEvents();
    }

    updateUniverseEventCountEvents(){
        let data = {
            'action': 'get_event_count_by_universe',
            'post_types': this.getTypes(),
        };

        let that = this;

        $.ajax({
            type: "POST",
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).done((response) => {
            that.updateCountByType('universe', response.event_counts);
            that.toggleLoader(that.UNIVERSE_LOADER,false);
        }).error((response) => {
            console.error('AJAX Error Response',response);
        });
    }

    updateUniverseEventCountELearning(){
        let data = {
            'action': 'e_learning_count',
        };

        let that = this;

        $.ajax({
            type: "POST",
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).done((response) => {
            that.updateCountByType('universe', response.event_counts);
            that.toggleLoader(that.UNIVERSE_LOADER,false);
        }).error((response) => {
            console.error('AJAX Error Response',response);
        });
    }

    updateCountByType(type, data){
        this.getFilterCounts(type).each((index, el) => {
            el = jQuery(el);
            let key = el.data(type);
            $(el).html(data[key] ? data[key] : 0);
        });
    }

    updateLocationEventCount(){
        this.toggleLoader(this.LOCATION_LOADER,true);

        let data = {
            'action': 'get_event_count_by_location',
            'post_types': this.getTypes(),
            'universes': this.getUniverses(),
        };

        let that = this;

        $.ajax({
            type: "POST",
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).done((response) => {
            that.updateCountByType('location', response.event_counts);
            that.toggleLoader(that.LOCATION_LOADER,false);
        }).error((response) => {
            console.error('AJAX Error Response',response);
        });
    }

}